import React from 'react';
import { shape, string, oneOfType, number, bool, object, oneOf } from 'prop-types';
import { currencyFormatter } from '@magalu/stereo-ui-utils';
import Flex from '../../../atoms/Flex';
import { PriceDefault, PriceContent, PriceValue, OriginalPrice, Discount, MethodDescription } from '../price.styles';
import Installment from '../../Installment';
import { inCash, discount as discountLabel } from '../price.text';
import { returnDiscountInfo, returnInstallmentInfo, returnPriceInfo } from './price-default.utils';

const PriceDefaultComponent = ({
  discount,
  finalPrice,
  hideOriginalPrice,
  installment,
  isList,
  minimumInstallment,
  installmentFormat,
  paymentMethodDescription,
  price,
  showDiscount,
  showDiscountOnlyCashInfo,
  showInCashInfo,
  style
}) => {
  const {
    hasInstallment,
    installmentPrice,
    isInstallmentWithoutInterest
  } = returnInstallmentInfo({
    installment,
    minimumInstallment
  });
  const {
    showOriginalPrice
  } = returnPriceInfo({
    finalPrice,
    hideOriginalPrice,
    installmentPrice,
    isInstallmentWithoutInterest,
    price
  });
  const {
    showDiscountValue
  } = returnDiscountInfo({
    finalPrice,
    installmentPrice,
    showDiscount,
    showDiscountOnlyCashInfo,
    showInCashInfo
  });
  return /*#__PURE__*/React.createElement(PriceContent, style, /*#__PURE__*/React.createElement(PriceDefault, {
    "data-testid": "price-default",
    isList: isList
  }, /*#__PURE__*/React.createElement(React.Fragment, null, showOriginalPrice && /*#__PURE__*/React.createElement(OriginalPrice, {
    "data-testid": "price-original",
    isList: isList
  }, currencyFormatter({
    value: price
  })), hasInstallment && /*#__PURE__*/React.createElement(Installment, {
    mt: 2,
    information: installment,
    minimumInstallment: minimumInstallment,
    isList: isList,
    format: installmentFormat
  }), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(PriceValue, {
    "data-testid": "price-value"
  }, hasInstallment && /*#__PURE__*/React.createElement("span", null, "ou "), currencyFormatter({
    value: finalPrice
  })), paymentMethodDescription ? /*#__PURE__*/React.createElement(MethodDescription, {
    "data-testid": "in-cash"
  }, paymentMethodDescription, ' ') : /*#__PURE__*/React.createElement(React.Fragment, null, (!installmentPrice || parseFloat(finalPrice) < parseFloat(installmentPrice)) && /*#__PURE__*/React.createElement(MethodDescription, {
    "data-testid": "in-cash"
  }, inCash))), showDiscountValue && /*#__PURE__*/React.createElement(Discount, {
    as: "span"
  }, "(", `${Number(discount)}${discountLabel}`, ")"))));
};

process.env.NODE_ENV !== "production" ? PriceDefaultComponent.propTypes = {
  discount: oneOfType([string, number]),
  finalPrice: oneOfType([string, number]),
  hideOriginalPrice: bool,
  installment: shape({
    amount: oneOfType([string, number]),
    paymentMethodDescription: string,
    quantity: oneOfType([string, number]),
    totalAmount: oneOfType([string, number])
  }),
  isList: bool,
  installmentFormat: oneOf(['short', 'full', null]),
  minimumInstallment: number,
  paymentMethodDescription: oneOfType([string, number]),
  price: oneOfType([string, number]),
  showDiscount: bool,
  showDiscountOnlyCashInfo: bool,
  showInCashInfo: bool,
  style: object
} : void 0;
PriceDefaultComponent.defaultProps = {
  hideOriginalPrice: false
};
export default PriceDefaultComponent;